import { Favorites } from '@widgets/favorites'

export default function FavoritesPage () {
  return <Favorites />
}
